import { Component, ChangeDetectionStrategy, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getCompany } from '@lx/shared/tokens';
import { COMPANIES } from '@lx/shared/types';

/**
 * AcquisitionDisclaimer Component
 *
 * Displays an acquisition disclaimer message specific to each company.
 * - For Kaplan: "Kaplan Languages Group is now part of Inspirit Capital. Use of the Kaplan brand under licence."
 * - For Alpadia: "In 2026, Alpadia was acquired by Inspirit Capital."
 * - Not displayed for other companies (ESL)
 *
 * @example
 * // In your component template:
 * <lx-acquisition-disclaimer></lx-acquisition-disclaimer>
 */
@Component({
  standalone: true,
  selector: 'lx-acquisition-disclaimer',
  imports: [CommonModule],
  templateUrl: './acquisition-disclaimer.component.html',
  styleUrls: ['./acquisition-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcquisitionDisclaimerComponent {
  private readonly company = getCompany();

  /**
   * Indicates if the disclaimer should be visible
   * Only shown for Kaplan and Alpadia companies.
   * ESL won't need it so add the check just in case it is included by mistake on an ESL component
   */
  protected readonly disclaimerVisible = computed(() => {
    return this.company === COMPANIES.KAPLAN || this.company === COMPANIES.ALPADIA;
  });

  /**
   * Returns the appropriate disclaimer message based on the company
   */
  protected readonly disclaimerMessage = computed(() => {
    if (this.company === COMPANIES.KAPLAN) {
      return $localize`Kaplan Languages Group is now part of Inspirit Capital. Use of the Kaplan brand under licence.`;
    }
    if (this.company === COMPANIES.ALPADIA) {
      return $localize`In 2026, Alpadia was acquired by Inspirit Capital.`;
    }
    return '';
  });
}
